export default __webpack_public_path__ + "images/FG.4124083.png";